import React from 'react';

import {Route} from 'react-router';
///todo: convert to function
import Home from './components/Home';
import {Calendar} from './components/Calendar';
import LiveRooms from './components/LiveRooms';
import CompletedRooms from './components/CompletedRooms';
import TeamMatchStats from './components/TeamMatchStats';
import Scoring from './components/Scoring'
import Review from './components/Review';
import TrainingFixtures from './components/TrainingFixtures';

//Admin
import Admin from './components/Admin';
import AdminFixtures from './components/Admin/Fixtures';

import Layout from './components/Layout';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import {ApplicationPaths} from './components/api-authorization/ApiAuthorizationConstants';
import NotificationPanel from './components/Notification';

import {createStore, applyMiddleware} from 'redux'
import {Provider} from 'react-redux'
import thunk from 'redux-thunk';

import scoringReducer from './reducers'

import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './custom.css'

// creating the redux store
const store = createStore(
    scoringReducer,
    applyMiddleware(thunk)
);

const App = () => {
    return (
        <Layout>
            <NotificationPanel/>
            <div>
                <Provider store={store}>
                    <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes}/>
                    <AuthorizeRoute exact path='/' component={Home} requireRole={['Watcher', 'Manager', 'Uploader']}/>
                    <AuthorizeRoute exact path='/home' component={Home}
                                    requireRole={['Watcher', 'Manager', 'Uploader']}/>
                    <AuthorizeRoute exact path='/training' component={TrainingFixtures}
                                    requireRole={['Watcher', 'Manager']}/>
                    <AuthorizeRoute exact path='/admin' component={Admin} requireRole={['Admin']}/>
                    <AuthorizeRoute exact path='/admin/fixtures' component={AdminFixtures} requireRole={['Admin']}/>
                    <AuthorizeRoute exact path='/calendar' component={Calendar}
                                    requireRole={['Watcher', 'Manager', 'Uploader']}/>
                    <AuthorizeRoute exact path='/liverooms' component={LiveRooms} requireRole={['Watcher', 'Manager']}/>
                    <AuthorizeRoute exact path='/completed-rooms' component={CompletedRooms}
                                    requireRole={['Watcher', 'Manager']}/>
                    <AuthorizeRoute exact path='/team/:teamId/matchstats' component={TeamMatchStats}
                                    requireRole={['Watcher', 'Manager']}/>
                    <AuthorizeRoute exact path='/scoring/:fixtureRoomId' component={Scoring}
                                    requireRole={['Watcher', 'Manager']}/>
                    <AuthorizeRoute exact path='/scoring/:fixtureRoomId/review' component={Review}
                                    requireRole={['Watcher', 'Manager']}/>
                </Provider>
            </div>
        </Layout>
    );
}

App.displayName = App.name;

export default App;